/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaGiftCardCreationViewProps } from './citta-gift-card-creation';

export default (props: ICittaGiftCardCreationViewProps) => {
    const { GiftCardCreationModuleProps, GiftCardWrapNodeProps, GiftCardErrorNodeProps, GiftCardLeft, GiftCardRight, GiftCardErrors, GiftCardAddToCartErrorsNodeProps, GiftCardAddToCartErrors } = props;
    // const { resources } = props;
    return (
        <Module {...GiftCardCreationModuleProps}>
            <Node {...GiftCardWrapNodeProps}>
                { GiftCardLeft }
                { GiftCardRight }
            </Node>
            <Node {...GiftCardErrorNodeProps}>
               { GiftCardErrors }
            </Node>
            <Node {...GiftCardAddToCartErrorsNodeProps}>
                { GiftCardAddToCartErrors }
            </Node>
        </Module>
    );
};
